import React from 'react';

import { useIsMobile } from '../../../../../../../hooks';

import styles from './DataDots.module.scss';

type Props = {
    titles: string[];
    values: string[];
    isLoading?: boolean;
};

const DataDots = (props: Props) => {
  const { titles, values, isLoading } = props;
  const isMobile = useIsMobile();

  return (
    <div className={styles.financialData}>
      <div className={styles.textBox}>
        <div className={styles.blueDot} />
        {isLoading ? (
          <div>
            <div className={styles.loadingLine} />
            {isMobile && <div className={styles.loadingLine} />}
          </div>
        ) : (
          <div className={styles.text}>
            <div className={styles.key}>
              {titles[0]}
            </div>
            <div className={styles.value}>
              {values[0]}
            </div>
          </div>
        )}
      </div>
      <div className={styles.textBox}>
        <div className={styles.orangeDot} />
        {isLoading ? (
          <div>
            <div className={styles.loadingLine} />
            {isMobile && <div className={styles.loadingLine} />}
          </div>
        ) : (
          <div className={styles.text}>
            <div className={styles.key}>
              {titles[1]}
            </div>
            <div className={styles.value}>
              {values[1]}
            </div>
          </div>
        )}
      </div>
      {titles[2] && values[2] && (
      <div className={styles.textBox}>
        <div className={styles.pinkDot} />
        <div className={styles.text}>
          <div className={styles.key}>
            {titles[2]}
          </div>
          <div className={styles.value}>
            {values[2]}
          </div>
        </div>
      </div>
      )}
    </div>
  );
};

export default DataDots;
